"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        height: 350,
    },
};
var description = 'This is how you get a DrawerItem when pass only text prop.';
var code = "import React from 'react';\nimport { Drawer, DrawerItem } from c-react-ui';\n\nconst style = {\n  height: 350,\n};\n\nconst DrawerItemExample = () => (\n  <Drawer style={style}>\n    <DrawerItem text=\"Item\" />\n  </Drawer>\n);";
exports.RawExampleDrawerItem = function () { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.Drawer, { style: componentStyle.base },
        React.createElement(components_1.DrawerItem, { text: "Item" })))); };
exports.RawExampleDrawerItem.displayName = 'RawExampleDrawerItem';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerItemPage/RawExampleDrawerItem.tsx
// module id = 655
// module chunks = 0